export const VACANCY = {
    "date_from": "2025-03-01",
    "date_to": "2025-03-15",
    "vacancy_type": "Vacancy",
    "summary": [
        {
            "title": "Ср. время закрытия вакансии",
            "value": "42,14",
            "delta": "+3.7%"
        },
        {
            "title": "Ср. стоимость кандидата",
            "value": null,
            "delta": null
        },
        {
            "title": "Средняя конверсия",
            "value": "30.8%",
            "delta": "+3.7%"
        },
        {
            "title": "Найм/План",
            "hired_value": 600,
            "planned_value": 700,
            "hired_delta": "+2.4%",
            "planned_delta": "-3%"
        }
    ],
    "basic_data": {
        "data": [
            {
                "title": "Грузчик",
                "time": "50,2",
                "conversion_value": "2.8%",
                "conversion_delta": "+6.7%"
            },
            {
                "title": "Водитель",
                "time": "45,5",
                "conversion_value": "2.5%",
                "conversion_delta": "+7.5%"
            },
            {
                "title": "Сварщик",
                "time": "60",
                "conversion_value": "3.0%",
                "conversion_delta": "-1.2%"
            },
            {
                "title": "Монтажник",
                "time": "55",
                "conversion_value": "2.9%",
                "conversion_delta": "+4.3%"
            },
            {
                "title": "Механик",
                "time": null,
                "conversion_value": "2.6%",
                "conversion_delta": "+3.1%"
            }
        ],
        "total": {
            "average_time": "42,14",
            "average_conversion_value": "30.8%",
            "average_conversion_delta": "+3.7%"
        }
    },
    "hire_plan": {
        "data": [
            {
                "title": "Грузчик",
                "hire": 50,
                "plan": 70,
                "managers": 2
            },
            {
                "title": "Водитель",
                "hire": 30,
                "plan": 50,
                "managers": 1
            },
            {
                "title": "Сварщик",
                "hire": 40,
                "plan": 60,
                "managers": 2
            },
            {
                "title": "Монтажник",
                "hire": 25,
                "plan": 40,
                "managers": 1
            },
            {
                "title": "Механик",
                "hire": 30,
                "plan": 50,
                "managers": 1
            }
        ]
    },
    "source_analysis": [
        {
            "title": "Авито",
            "applied_count": 525,
            "hired_count": 150,
            "applied_share": "25.6%",
            "applied_delta": "+6.7%"
        },
        {
            "title": "Ресерчер",
            "applied_count": 400,
            "hired_count": 127,
            "applied_share": "19.6%",
            "applied_delta": "-6.7%"
        },
        {
            "title": "Архив",
            "applied_count": 320,
            "hired_count": 103,
            "applied_share": "15.6%",
            "applied_delta": "+6.7%"
        },
        {
            "title": "Приложение",
            "applied_count": 280,
            "hired_count": 90,
            "applied_share": "13.7%",
            "applied_delta": "-1.7%"
        },
        {
            "title": "Холодный поиск",
            "applied_count": 280,
            "hired_count": 90,
            "applied_share": "13.7%",
            "applied_delta": "+6.7%"
        },
        {
            "title": "Рефералка",
            "applied_count": 120,
            "hired_count": 36,
            "applied_share": "5.9%",
            "applied_delta": "+6.7%"
        },
        {
            "title": "Другие",
            "applied_count": 120,
            "hired_count": 36,
            "applied_share": "5.9%",
            "applied_delta": "+6.7%"
        }
    ],
    "rejection_reasons": {
        "data": [
            {
                "title": "Руководитель не согласовал",
                "count": 250,
                "share": "48%"
            },
            {
                "title": "Отказ в пропуске",
                "count": 100,
                "share": "19.2%"
            },
            {
                "title": "Другие",
                "count": 52,
                "share": "10%"
            },
            {
                "title": "По здоровью",
                "count": 50,
                "share": "9.6%"
            },
            {
                "title": "Недостаточно опыта",
                "count": 40,
                "share": "7.8%"
            },
            {
                "title": "Перестал выходить на связь",
                "count": 20,
                "share": "3.8%"
            },
            {
                "title": "Семейные обстоятельства",
                "count": 8,
                "share": "1.6%"
            }
        ],
        "total_rejections": 520
    },
    "rejection_dynamics": {
        "data": [
            {
                "title": "Руководитель не согласовал",
                "count": 250,
                "share": "+5%"
            },
            {
                "title": "Отказ в пропуске",
                "count": 100,
                "share": "-2%"
            },
            {
                "title": "Другие",
                "count": 52,
                "share": "+1%"
            },
            {
                "title": "По здоровью",
                "count": 50,
                "share": "+0.5%"
            },
            {
                "title": "Недостаточно опыта",
                "count": 40,
                "share": "-1%"
            },
            {
                "title": "Перестал выходить на связь",
                "count": 20,
                "share": "+0.3%"
            },
            {
                "title": "Семейные обстоятельства",
                "count": 8,
                "share": "+0.1%"
            }
        ]
    },
    "funnel": {
        "data": [
            {
                "title": "Грузчик",
                "total": {
                    "value": 320,
                    "share": "100%",
                    "delta_value": "+16",
                    "delta_percent": "+3.3%"
                },
                "resume": {
                    "value": 256,
                    "share": "80.0%",
                    "delta_value": "-16",
                    "delta_percent": "+7.1%"
                },
                "documents": {
                    "value": 197,
                    "share": "61.6%",
                    "delta_value": "+30",
                    "delta_percent": "+4.6%"
                },
                "medical_check": {
                    "value": 163,
                    "share": "50.9%",
                    "delta_value": "-30",
                    "delta_percent": "+6.4%"
                },
                "tickets": {
                    "value": 123,
                    "share": "38.4%",
                    "delta_value": "-45",
                    "delta_percent": "+6.5%"
                },
                "accepted": {
                    "value": 103,
                    "share": "32.2%",
                    "delta_value": "-12",
                    "delta_percent": "-6.7%"
                },
                "conversion": {
                    "value": "32.2%",
                    "delta": "+0.5%"
                }
            },
            {
                "title": "Водитель",
                "total": {
                    "value": 400,
                    "share": "100%",
                    "delta_value": "+25",
                    "delta_percent": "+2.1%"
                },
                "resume": {
                    "value": 320,
                    "share": "80.0%",
                    "delta_value": "+36",
                    "delta_percent": "-2.3%"
                },
                "documents": {
                    "value": 252,
                    "share": "63.0%",
                    "delta_value": "+22",
                    "delta_percent": "+5.4%"
                },
                "medical_check": {
                    "value": 209,
                    "share": "52.2%",
                    "delta_value": "+34",
                    "delta_percent": "-6.4%"
                },
                "tickets": {
                    "value": 165,
                    "share": "41.2%",
                    "delta_value": "-35",
                    "delta_percent": "-4.9%"
                },
                "accepted": {
                    "value": 127,
                    "share": "31.8%",
                    "delta_value": "+6",
                    "delta_percent": "-3.1%"
                },
                "conversion": {
                    "value": "31.8%",
                    "delta": "+1.3%"
                }
            },
            {
                "title": "Сварщик",
                "total": {
                    "value": 525,
                    "share": "100%",
                    "delta_value": "+36",
                    "delta_percent": "+8.5%"
                },
                "resume": {
                    "value": 409,
                    "share": "77.9%",
                    "delta_value": "-48",
                    "delta_percent": "-6.0%"
                },
                "documents": {
                    "value": 310,
                    "share": "59.0%",
                    "delta_value": "-11",
                    "delta_percent": "+8.2%"
                },
                "medical_check": {
                    "value": 244,
                    "share": "46.5%",
                    "delta_value": "-5",
                    "delta_percent": "-3.2%"
                },
                "tickets": {
                    "value": 200,
                    "share": "38.1%",
                    "delta_value": "-37",
                    "delta_percent": "-4.5%"
                },
                "accepted": {
                    "value": 150,
                    "share": "28.6%",
                    "delta_value": "+49",
                    "delta_percent": "-0.5%"
                },
                "conversion": {
                    "value": "28.6%",
                    "delta": "-1.9%"
                }
            },
            {
                "title": "Монтажник",
                "total": {
                    "value": 280,
                    "share": "100%",
                    "delta_value": "+30",
                    "delta_percent": "-8.0%"
                },
                "resume": {
                    "value": 224,
                    "share": "80.0%",
                    "delta_value": "+18",
                    "delta_percent": "+2.3%"
                },
                "documents": {
                    "value": 188,
                    "share": "67.1%",
                    "delta_value": "+17",
                    "delta_percent": "-2.0%"
                },
                "medical_check": {
                    "value": 141,
                    "share": "50.4%",
                    "delta_value": "-10",
                    "delta_percent": "+6.0%"
                },
                "tickets": {
                    "value": 118,
                    "share": "42.1%",
                    "delta_value": "+16",
                    "delta_percent": "+3.7%"
                },
                "accepted": {
                    "value": 90,
                    "share": "32.1%",
                    "delta_value": "+7",
                    "delta_percent": "-2.1%"
                },
                "conversion": {
                    "value": "32.1%",
                    "delta": "-2.5%"
                }
            },
            {
                "title": "Механик",
                "total": {
                    "value": 120,
                    "share": "100%",
                    "delta_value": "+16",
                    "delta_percent": "+6.8%"
                },
                "resume": {
                    "value": 97,
                    "share": "80.8%",
                    "delta_value": "-19",
                    "delta_percent": "-3.5%"
                },
                "documents": {
                    "value": 82,
                    "share": "68.3%",
                    "delta_value": "-45",
                    "delta_percent": "-1.4%"
                },
                "medical_check": {
                    "value": 61,
                    "share": "50.8%",
                    "delta_value": "+43",
                    "delta_percent": "-1.7%"
                },
                "tickets": {
                    "value": 46,
                    "share": "38.3%",
                    "delta_value": "-9",
                    "delta_percent": "+2.8%"
                },
                "accepted": {
                    "value": 36,
                    "share": "30.0%",
                    "delta_value": "+28",
                    "delta_percent": "+5.1%"
                },
                "conversion": {
                    "value": "30.0%",
                    "delta": "-4.4%"
                }
            }
        ],
        "total": {
            "total": {
                "value": 1645,
                "share": "100%",
                "delta_value": "+29",
                "delta_percent": "+3.2%"
            },
            "resume": {
                "value": 1306,
                "share": "79.4%",
                "delta_value": "-21",
                "delta_percent": "+4.7%"
            },
            "documents": {
                "value": 1029,
                "share": "62.6%",
                "delta_value": "+42",
                "delta_percent": "+1.7%"
            },
            "medical_check": {
                "value": 818,
                "share": "49.7%",
                "delta_value": "-25",
                "delta_percent": "-4.2%"
            },
            "tickets": {
                "value": 652,
                "share": "39.6%",
                "delta_value": "-37",
                "delta_percent": "+3.7%"
            },
            "accepted": {
                "value": 506,
                "share": "30.8%",
                "delta_value": "+17",
                "delta_percent": "+0.9%"
            },
            "conversion": {
                "value": "30.8%",
                "delta": "+3.7%"
            }
        }
    }
}

export const MANAGER = {
    "date_from": "2025-03-01",
    "date_to": "2025-03-15",
    "vacancy_type": "Manager",
    "summary": [
        {
            "title": "Ср. время закрытия вакансии",
            "value": "42,14",
            "delta": "+3.7%"
        },
        {
            "title": "Ср. стоимость кандидата",
            "value": null,
            "delta": null
        },
        {
            "title": "Средняя конверсия",
            "value": "30.8%",
            "delta": "+3.7%"
        },
        {
            "title": "Найм/План",
            "hired_value": 600,
            "planned_value": 700,
            "hired_delta": "+2.4%",
            "planned_delta": "-3%"
        }
    ],
    "basic_data": {
        "data": [
            {
                "title": "Андрей Ялымов",
                "time": "48,5",
                "conversion_value": "3.1%",
                "conversion_delta": "+5.4%",
                "closed_value": 15,
                "closed_delta": "+5%"
            },
            {
                "title": "Виктор Боронин",
                "time": "46,5",
                "conversion_value": "2.9%",
                "conversion_delta": "+4.8%",
                "closed_value": 10,
                "closed_delta": "-2%"
            },
            {
                "title": "Алексей Васильев",
                "time": "50,2",
                "conversion_value": "3.0%",
                "conversion_delta": "+6.1%",
                "closed_value": 20,
                "closed_delta": "0%"
            },
            {
                "title": "Ирина Смирнова",
                "time": "47,5",
                "conversion_value": "2.7%",
                "conversion_delta": "+3.9%",
                "closed_value": 8,
                "closed_delta": "-10%"
            },
            {
                "title": "Ольга Кузнецова",
                "time": "49,0",
                "conversion_value": "2.8%",
                "conversion_delta": "+4.2%",
                "closed_value": 20,
                "closed_delta": "0%"
            }
        ],
        "total": {
            "average_time": "48,24",
            "average_conversion_value": "2.9%",
            "average_conversion_delta": "+4.88%",
            "average_closed_value": "14,6",
            "average_closed_delta": "+4,6%"

        }
    },
    "rejection_reasons": {
        "data": [
            {
                "title": "Руководитель не согласовал",
                "count": 240,
                "share": "46%"
            },
            {
                "title": "Отказ в пропуске",
                "count": 110,
                "share": "21%"
            },
            {
                "title": "Другие",
                "count": 60,
                "share": "11.5%"
            },
            {
                "title": "По здоровью",
                "count": 45,
                "share": "8.6%"
            },
            {
                "title": "Недостаточно опыта",
                "count": 35,
                "share": "6.7%"
            },
            {
                "title": "Перестал выходить на связь",
                "count": 20,
                "share": "3.8%"
            },
            {
                "title": "Семейные обстоятельства",
                "count": 10,
                "share": "1.9%"
            }
        ],
        "total_rejections": 520
    },
    "rejection_dynamics": {
        "data": [
            {
                "title": "Руководитель не согласовал",
                "count": 250,
                "share": "+5%"
            },
            {
                "title": "Отказ в пропуске",
                "count": 100,
                "share": "-2%"
            },
            {
                "title": "Другие",
                "count": 52,
                "share": "+1%"
            },
            {
                "title": "По здоровью",
                "count": 50,
                "share": "+0.5%"
            },
            {
                "title": "Недостаточно опыта",
                "count": 40,
                "share": "-1%"
            },
            {
                "title": "Перестал выходить на связь",
                "count": 20,
                "share": "+0.3%"
            },
            {
                "title": "Семейные обстоятельства",
                "count": 8,
                "share": "+0.1%"
            }
        ]
    },
    "source_analysis": [
        {
            "title": "Авито",
            "applied_count": 525,
            "hired_count": 150,
            "applied_share": "25.6%",
            "applied_delta": "+6.7%"
        },
        {
            "title": "Ресерчер",
            "applied_count": 400,
            "hired_count": 127,
            "applied_share": "19.6%",
            "applied_delta": "-6.7%"
        },
        {
            "title": "Архив",
            "applied_count": 320,
            "hired_count": 103,
            "applied_share": "15.6%",
            "applied_delta": "+6.7%"
        },
        {
            "title": "Приложение",
            "applied_count": 280,
            "hired_count": 90,
            "applied_share": "13.7%",
            "applied_delta": "-1.7%"
        },
        {
            "title": "Холодный поиск",
            "applied_count": 280,
            "hired_count": 90,
            "applied_share": "13.7%",
            "applied_delta": "+6.7%"
        },
        {
            "title": "Рефералка",
            "applied_count": 120,
            "hired_count": 36,
            "applied_share": "5.9%",
            "applied_delta": "+6.7%"
        },
        {
            "title": "Другие",
            "applied_count": 120,
            "hired_count": 36,
            "applied_share": "5.9%",
            "applied_delta": "+6.7%"
        }
    ],
    "funnel": {
        "data": [
            {
                "title": "Андрей Ялымов",
                "total": {
                    "value": 320,
                    "share": "100%",
                    "delta_value": "+16",
                    "delta_percent": "+3.3%"
                },
                "resume": {
                    "value": 256,
                    "share": "80.0%",
                    "delta_value": "-16",
                    "delta_percent": "+7.1%"
                },
                "documents": {
                    "value": 197,
                    "share": "61.6%",
                    "delta_value": "+30",
                    "delta_percent": "+4.6%"
                },
                "medical_check": {
                    "value": 163,
                    "share": "50.9%",
                    "delta_value": "-30",
                    "delta_percent": "+6.4%"
                },
                "tickets": {
                    "value": 123,
                    "share": "38.4%",
                    "delta_value": "-45",
                    "delta_percent": "+6.5%"
                },
                "accepted": {
                    "value": 103,
                    "share": "32.2%",
                    "delta_value": "-12",
                    "delta_percent": "-6.7%"
                },
                "conversion": {
                    "value": "32.2%",
                    "delta": "+0.5%"
                }
            },
            {
                "title": "Виктор Боронин",
                "total": {
                    "value": 400,
                    "share": "100%",
                    "delta_value": "+25",
                    "delta_percent": "+2.1%"
                },
                "resume": {
                    "value": 320,
                    "share": "80.0%",
                    "delta_value": "+36",
                    "delta_percent": "-2.3%"
                },
                "documents": {
                    "value": 252,
                    "share": "63.0%",
                    "delta_value": "+22",
                    "delta_percent": "+5.4%"
                },
                "medical_check": {
                    "value": 209,
                    "share": "52.2%",
                    "delta_value": "+34",
                    "delta_percent": "-6.4%"
                },
                "tickets": {
                    "value": 165,
                    "share": "41.2%",
                    "delta_value": "-35",
                    "delta_percent": "-4.9%"
                },
                "accepted": {
                    "value": 127,
                    "share": "31.8%",
                    "delta_value": "+6",
                    "delta_percent": "-3.1%"
                },
                "conversion": {
                    "value": "31.8%",
                    "delta": "+1.3%"
                }
            },
            {
                "title": "Алексей Васильев",
                "total": {
                    "value": 525,
                    "share": "100%",
                    "delta_value": "+36",
                    "delta_percent": "+8.5%"
                },
                "resume": {
                    "value": 409,
                    "share": "77.9%",
                    "delta_value": "-48",
                    "delta_percent": "-6.0%"
                },
                "documents": {
                    "value": 310,
                    "share": "59.0%",
                    "delta_value": "-11",
                    "delta_percent": "+8.2%"
                },
                "medical_check": {
                    "value": 244,
                    "share": "46.5%",
                    "delta_value": "-5",
                    "delta_percent": "-3.2%"
                },
                "tickets": {
                    "value": 200,
                    "share": "38.1%",
                    "delta_value": "-37",
                    "delta_percent": "-4.5%"
                },
                "accepted": {
                    "value": 150,
                    "share": "28.6%",
                    "delta_value": "+49",
                    "delta_percent": "-0.5%"
                },
                "conversion": {
                    "value": "28.6%",
                    "delta": "-1.9%"
                }
            },
            {
                "title": "Ирина Смирнова",
                "total": {
                    "value": 280,
                    "share": "100%",
                    "delta_value": "+30",
                    "delta_percent": "-8.0%"
                },
                "resume": {
                    "value": 224,
                    "share": "80.0%",
                    "delta_value": "+18",
                    "delta_percent": "+2.3%"
                },
                "documents": {
                    "value": 188,
                    "share": "67.1%",
                    "delta_value": "+17",
                    "delta_percent": "-2.0%"
                },
                "medical_check": {
                    "value": 141,
                    "share": "50.4%",
                    "delta_value": "-10",
                    "delta_percent": "+6.0%"
                },
                "tickets": {
                    "value": 118,
                    "share": "42.1%",
                    "delta_value": "+16",
                    "delta_percent": "+3.7%"
                },
                "accepted": {
                    "value": 90,
                    "share": "32.1%",
                    "delta_value": "+7",
                    "delta_percent": "-2.1%"
                },
                "conversion": {
                    "value": "32.1%",
                    "delta": "-2.5%"
                }
            },
            {
                "title": "Ольга Кузнецова",
                "total": {
                    "value": 120,
                    "share": "100%",
                    "delta_value": "+16",
                    "delta_percent": "+6.8%"
                },
                "resume": {
                    "value": 97,
                    "share": "80.8%",
                    "delta_value": "-19",
                    "delta_percent": "-3.5%"
                },
                "documents": {
                    "value": 82,
                    "share": "68.3%",
                    "delta_value": "-45",
                    "delta_percent": "-1.4%"
                },
                "medical_check": {
                    "value": 61,
                    "share": "50.8%",
                    "delta_value": "+43",
                    "delta_percent": "-1.7%"
                },
                "tickets": {
                    "value": 46,
                    "share": "38.3%",
                    "delta_value": "-9",
                    "delta_percent": "+2.8%"
                },
                "accepted": {
                    "value": 36,
                    "share": "30.0%",
                    "delta_value": "+28",
                    "delta_percent": "+5.1%"
                },
                "conversion": {
                    "value": "30.0%",
                    "delta": "-4.4%"
                }
            }
        ],
        "total": {
            "total": {
                "value": 1645,
                "share": "100%",
                "delta_value": "+29",
                "delta_percent": "+3.2%"
            },
            "resume": {
                "value": 1306,
                "share": "79.4%",
                "delta_value": "-21",
                "delta_percent": "+4.7%"
            },
            "documents": {
                "value": 1029,
                "share": "62.6%",
                "delta_value": "+42",
                "delta_percent": "+1.7%"
            },
            "medical_check": {
                "value": 818,
                "share": "49.7%",
                "delta_value": "-25",
                "delta_percent": "-4.2%"
            },
            "tickets": {
                "value": 652,
                "share": "39.6%",
                "delta_value": "-37",
                "delta_percent": "+3.7%"
            },
            "accepted": {
                "value": 506,
                "share": "30.8%",
                "delta_value": "+17",
                "delta_percent": "+0.9%"
            },
            "conversion": {
                "value": "30.8%",
                "delta": "+3.7%"
            }
        }
    }
}


